import {
  useWorkflowThree,
  generateWfThreePdfReportbyId,
} from "../../../../../libs/apis";
import { ShowContainer } from "../../../../../components/workflow-three/components/list/show-container";
import { WorkflowProcessTable } from "./workflow-process-table";

const useWorkflowThreeList = (params: Parameters<typeof useWorkflowThree>[0]) =>
  useWorkflowThree(params).workflowThreesQuery;

const WorkflowThreeListComponent = () => (
  <WorkflowProcessTable
    useList={useWorkflowThreeList}
    generatePdf={generateWfThreePdfReportbyId}
    type="three"
    number={3}
    ShowContainer={ShowContainer}
  />
);

export default WorkflowThreeListComponent;
